import React, { useRef } from 'react'
import {
    HeaderHero,
    HeaderBody,
    HeaderContent,
    HeaderHeading,
    HeaderButtonWrap,
} from '../../utils/commonStyles'
import ExpandButton from '../../utils/ExpandButton'
import { Columns } from 'react-bulma-components'
import styled from 'styled-components'
import { device } from '../../utils/device'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const StyledBoxColumn = styled.div`
    position: relative;
    @media ${device.tablet} {
        margin: 0.75em;
        padding: 0;
    }
`

export default function () {
    const { t } = useTranslation()
    const containerEl = useRef()

    return (
        <HeaderHero>
            <HeaderBody>
                <div className={'container'} ref={containerEl}>
                    <Columns>
                        <Columns.Column
                            desktop={{ size: 'two-thirds' }}
                            tablet={{
                                size: 'half',
                            }}
                            mobile={{
                                size: 12,
                            }}
                        >
                            <HeaderHeading size={1}>
                                {t('onas.header.title')}
                            </HeaderHeading>
                            <HeaderContent>
                                <p>{t('onas.header.subtitle')}</p>
                                <HeaderButtonWrap>
                                    <ExpandButton href={'tel:0036541341449'}>
                                        041 341 449
                                    </ExpandButton>
                                    <ExpandButton href={'mailto:info@kisik.si'}>
                                        info@kisik.si
                                    </ExpandButton>
                                </HeaderButtonWrap>
                            </HeaderContent>
                        </Columns.Column>
                        <StyledBoxColumn className={'column'}></StyledBoxColumn>
                    </Columns>
                </div>
            </HeaderBody>
        </HeaderHero>
    )
}
